import React from 'react';

const Quantity = ({ quantity, onChangeQuantity }) => {

  const onChange = (e) => {
    onChangeQuantity(e.target.value);
  };

  return (
    <div className="d-flex align-items-center quantity-block mt-2 mb-3">
      <div className="w-50 quantity-title">
        Quantity
      </div>
      <div className="w-50">
        <input
          type="number"
          className="form-control form-control-sm w-50"
          min="1"
          value={quantity || 1}
          onChange={onChange} />
      </div>
    </div>
  );
};

export default Quantity;
